import * as React from 'react';
import { useState, useEffect } from 'react';
import { StyledEngineProvider } from '@mui/material/styles';
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { ColorData } from "./../../fxms/datas/ColorData";


export const FxIconValuePanel = (props) => {
    const { energy, inloList, allValues } = props;
    const [icon, setIcon] = React.useState("steam_icon001.png");
    const [nowTot, setNowTot] = useState("");
    const [sumTot, setSumTot] = useState("");
    const [inlos, setInlos] = useState([]);

    console.log("*** FxIconValuePanel ***", energy, "allValues", allValues);
    const makeSeries = () => {

        const series = [];
        const values = allValues[energy.engId];
        const colors = new ColorData();
        if (values) {
            let index = 1;
            for (const inlo of inloList) {
                const s = {};
                s.name = inlo.inloName;
                s.type = 'line';
                s.data = [];
                s.color = colors.getNextColor(".color" + index);
                // s.color = colors.makeColor();
                if(values[inlo.inloNo] !== undefined) {
                    for (const data of values[inlo.inloNo].list) {
                        s.data.push(data.prodAmt);
                    }
                }
                series.push(s);
                index++;
            }
        }
        return series;
    }

    const getIcon = (x) => {
        let icon = 'steam_icon001.png';
        if (x === "AIR") {
            icon = 'air_icon001.png';
        } else if (x === "COOLWATER") {
            icon = 'water_icon001.png';
        } else if (x === "STEAM") {
            icon = 'steam_icon001.png';
        } else if(x === "ELEC"){
            icon = 'elec_icon001.png'
        } else if(x === "EPWR"){
            icon = 'epwr_icon001.png'
        }
        return icon
    }

    const getChartData = (title) => {
        return {
            title: {
                text: title,
                align: "center",
            },

            tooltip: {
                crosshairs: true,
                shared: true,
                valueSuffix: " ",
            },
            plotOptions: {
                series: {
                    animation: false,
                    dataLabels: {
                        enabled: true,
                        style: {
                            color: "white",
                            fontSize: "11px",
                            fontWeight: "bold",
                            textOutline: "1px 1px"
                        }
                    }
                }
            },
            xAxis: {
                lineWidth: 1,
                lineColor: '#3e3e3e',
                gridLineColor: '#3e3e3e',
                tickColor: '#3e3e3e'
            },
            yAxis: {
                lineWidth: 1,
                lineColor: '#3e3e3e',
                gridLineColor: '#3e3e3e'
            },
            chart: {
                backgroundColor: "#313131",
                borderWidth: 1,
                borderRadius: 0,
                borderColor: "#303030",
                plotBackgroundColor: "#303030",
                plotBorderWidth: 1,
                plotBorderColor: "#303030"
            },
            series: makeSeries()
            ,
            legend: {
                enabled: false
            }
        };
    }


    useEffect(() => {
        setIcon(getIcon(energy.engId))
    }, [energy])

    useEffect(() => {
        const values = allValues[energy.engId];
        const tmp = [];
        let tmpNowTot = 0;
        let tmpSumTot = 0;
        let index = 1;


        if (values === undefined) {
            return;
        }

        console.log("*** FxIconValuePanel ***", values);

        for (const inlo of inloList) {
            let engUnit = energy.engUnit+"/h";
            if (values && values[inlo.inloNo]) {
                tmpNowTot += values[inlo.inloNo].now;
                tmpSumTot += values[inlo.inloNo].sum;

                tmp.push(<div className="factory" key={inlo.inloNo}>
                    <div><span className={"color" + index}>●</span> {inlo.inloName}</div>
                    <div>{values[inlo.inloNo].now.toLocaleString()}</div>
                    <div>{engUnit}</div>
                </div>);
            } else {
                tmp.push(<div className="factory" key={inlo.inloNo}>
                    <div><span className={"color" + index}>●</span> {inlo.inloName}</div>
                    <div></div>
                    <div>{engUnit}</div>
                </div>);
            }
            index++;
        }

        setInlos(tmp);
        setNowTot(tmpNowTot);
        setSumTot(tmpSumTot);

    }, [allValues, inloList, energy.engId])


    return (
        <StyledEngineProvider injectFirst>
            <div className="FxIconValuePanel">
                <div className="FxIconValuePanelDashWrap">
                    <div className="boxCard">
                        <div className="FxIconValueWrap">
                            <img src={icon} /><span className="FxIconValueName">{energy.engName}</span>
                            <div className="FxIconValueBox">
                                <span className="FxIconValueText">적산</span>
                                <span className="FxIconValueValue">{sumTot.toLocaleString()}</span>
                                <span className="FxIconValueUnit">{energy.engUnit}</span>
                            </div>
                            <div className="FxIconValueBox">
                                <span className="FxIconValueText">순시</span>
                                <span className="FxIconValueValue">{nowTot.toLocaleString()}</span>
                                <span className="FxIconValueUnit">{energy.engUnit+'/h'}</span>
                            </div>
                        </div>
                        <div className="chart_container">
                            <HighchartsReact
                                containerProps={{ style: { height: "100%" } }}
                                highcharts={Highcharts}
                                options={getChartData('', '', '', '')}
                            /></div>
                        <div className="InloListDiv">
                            {inlos}
                        </div>
                    </div>
                </div>
            </div>
        </StyledEngineProvider>
    );
}